module.exports = __webpack_public_path__ + "static/img/zhuangxiu.25b90ec7.png";